<script>
export default {
  props: {
    id: {
      type: [String, Number, undefined],
      required: false,
      default: null,
    },
    leagueId: {
      type: [String, Number],
      required: false,
    },
  },
  data() {
    return {
      crudeForm: {
        league: '',
        name: '',
        kind: '',
      },
      form: this.crudeForm,
      rerenderComponent: false,
      league: null,
      title: '',
      typeOptions: [
        {
          name: 'Int',
          id: 0,
        },
        {
          name: 'Double',
          id: 1,
        },
        {
          name: 'String',
          id: 2,
        },
        {
          name: 'Boolean',
          id: 3,
        },
      ],
    }
  },
  computed: {
    isEditing() {
      return this.id != null && this.id != undefined
    },
  },
  watch: {
    '$route.fullPath': {
      immediate: true, // Immediate option to call watch handler on first mount
      handler() {
        this.resetForm()
      },
    },
  },
  mounted() {
    if (this.isEditing) {
      this.fetchRecord()
    }
  },
  methods: {
    fetchRecord() {
      this.$axios
        .get(`leagues/${this.leagueId}/data-fields/${this.id}`)
        .then((res) => {
          this.form = { ...this.form, ...res.data }
          this.form.kind = this.typeOptions.find(
            (x) => x.id === parseInt(this.form.kind)
          )
          this.rerenderComponent = true
        })
    },
    submitForm() {
      const data = JSON.parse(JSON.stringify(this.form))
      data.kind = data.kind.id
      data.league = undefined

      if (this.isEditing) {
        this.updateRecord(data)
      } else {
        this.createRecord(data)
      }
    },
    createRecord(data) {
      this.$axios
        .post(`leagues/${this.leagueId}/data-fields`, data)
        .then((res) => {
          this.$swal('موفق!', 'فیلد با موفقیت ثبت شد', 'success')
          if (this.$store.state.tables.league_data.league.id == this.leagueId) {
            this.$store.dispatch('tables/addNewItem', {
              key: 'league_data',
              item: res.data,
            })
          }
        })
    },
    updateRecord(data) {
      this.$axios
        .put(`leagues/${this.leagueId}/data-fields/${this.id}`, data)
        .then((res) => {
          this.$swal('موفق!', 'فیلد با موفقیت به روزرسانی شد', 'success')
          if (this.$store.state.tables.league_data.league.id == this.leagueId) {
            this.$store.dispatch('tables/updateItem', {
              key: 'league_data',
              item: res.data,
            })
          }
        })
    },
    resetForm() {
      this.rerenderComponent = false
      this.$nextTick(() => {
        this.form = this.crudeForm
        this.rerenderComponent = true
      })
    },
  },
}
</script>

<template>
  <div v-if="rerenderComponent">
    <div class="row mx-auto">
      <div class="col-12 px-0">
        <div class="card">
          <div class="card-body">
            <ValidationObserver v-slot="{ handleSubmit }" tag="div">
              <form
                class="needs-validation mt-4"
                @submit.prevent="handleSubmit(submitForm)"
              >
                <div class="row">
                  <div class="col-md-6">
                    <validation-input
                      v-model="form.name"
                      type="text"
                      placeholder="نام فیلد"
                      rules="required|enuStart"
                      validation-field-name="نام فیلد"
                      label="نام فیلد"
                    ></validation-input>
                  </div>
                  <div class="col-md-6">
                    <validation-select
                      :options="typeOptions"
                      v-model="form.kind"
                      validation-field-name="نوع فیلد"
                      option-value-key="id"
                      option-text-key="name"
                      label="نوع فیلد"
                      rules="required"
                      disabled
                    >
                    </validation-select>
                  </div>
                </div>
                <button
                  class="btn btn-primary mt-4"
                  style="float: left"
                  type="submit"
                >
                  {{ isEditing ? 'ویرایش فیلد' : 'ثبت فیلد' }}
                </button>
              </form>
            </ValidationObserver>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
